export default __webpack_public_path__ + "static/media/frytol_1.600587b6.png";